module.exports = __webpack_public_path__ + "assets/eye-079b8f7733e582709a3e65d9d4347ec8.svg";